import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class NegotiationActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsNegotiating' {
    return 'actionPointsNegotiating';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.NEGOTIATION;
  }
}
